<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  metaInfo: {
    title: '企业代理记账-上海机巧科技有限公司',
    meta: [
      { name: 'keywords', content: '注册公司_上海注册公司_注册上海公司_财务代理_上海代理记账' },
      { name: 'description', content: '机巧科技专注为企业提供智能财务SaaS解决方案及商脉资源拓展对接服务。提供：会计代理记账,公司注册代办服务,为初创小微企业提供了便捷的拍照式记账报税新体验，为中小企业解决财务方面的难题和痛点,同时也降低用人成本.' }
    ]
  },
  mounted () {
   document.dispatchEvent(new Event('render-event'));//加载完发布这个事件
    if (this._isMobile() === 1) {
      if(this.$router.history.current.name=='Tax'){
      }else if(this.$router.history.current.name=='Card'){
      }else{
          this.$router.replace('/mhome').catch(err => err)
      }
    }
    
  },
  methods: {
    _isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag ? 1 : 0
    }
  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue